/*
横幅960ピクセル未満で、パンくずリストを消してドロップダウンリストを
表示する
*/
function changeMenu(){
    $("#drop-menu").menu(
        { position: { my: 'left top', at: 'center top' } }
    );
    if ( window.innerWidth < 960) {
        $("#drop-menu").show();
        $("#breadcrumb").hide();
    } else {
        $("#drop-menu").hide();
        $("#breadcrumb").show();
    }
}
changeMenu();
$(window).bind('resize',{},changeMenu);



// WEBPACK FOOTER //
// ./src/bread-menu.js